import { Temporal } from 'temporal-polyfill';
import { z } from 'zod';
import { backgroundCheckStatusSchema, techCheckTypeSchema } from './coach-shared.js';

export const orgTypeSchema = z.enum(['district', 'individual', 'foundation']);
export const OrgType = orgTypeSchema.enum;
export type OrgType = z.infer<typeof orgTypeSchema>;

export const orgStatusSchema = z.enum(['active', 'inactive']);
export const OrgStatus = orgStatusSchema.enum;
export type OrgStatus = z.infer<typeof orgStatusSchema>;

export const videoConferenceTypeSchema = z.enum(['zoom', 'googleMeet']);
export const VideoConferenceType = videoConferenceTypeSchema.enum;
export type VideoConferenceType = z.infer<typeof videoConferenceTypeSchema>;
export const VideoConferenceTypeLabels: Record<VideoConferenceType, string> = {
  zoom: 'Zoom',
  googleMeet: 'Google Meet',
};

export const orgFeedbackTypeSchema = z.enum(['airFeedback', 'parentFeedback']);
export const OrgFeedbackType = orgFeedbackTypeSchema.enum;
export type OrgFeedbackType = z.infer<typeof orgFeedbackTypeSchema>;
export const OrgFeedbackTypeLabels: Record<OrgFeedbackType, string> = {
  airFeedback: 'AIR Feedback',
  parentFeedback: 'Parent Feedback',
};

export const orgSchema = z.object({
  type: z.literal('org'),
  id: z.string(),
  name: z.string(),
  kind: orgTypeSchema.nullable(),
  status: orgStatusSchema,
  timeZone: z.string(),
  videoConferenceType: videoConferenceTypeSchema,
  feedbackType: orgFeedbackTypeSchema,
  preliminaryStartPlainDate: z.instanceof(Temporal.PlainDate).nullable(),
  preliminaryEndPlainDate: z.instanceof(Temporal.PlainDate).nullable(),
  totalSeats: z.number(),
  teacherBackgroundCheckStatuses: z.array(backgroundCheckStatusSchema),
  teacherTechCheckTypes: z.array(techCheckTypeSchema),
  canSendEmailSMS: z.boolean().default(false),
  showSessionsToTeachers: z.boolean().default(false),
  edlinkId: z.string().nullable().optional(),
});
export type Org = z.infer<typeof orgSchema>;

export const minimalOrgSchema = z.object({
  id: z.string(),
  name: z.string(),
});
export type MinimalOrg = z.infer<typeof minimalOrgSchema>;

